"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Clock, Mail, Phone } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const hubs = [{
  code: "REG / 01 / HYD",
  name: "Hyderabad",
  region: "SOUTH INDIA",
  address: ["HITEC City", "Cyber Towers", "Hyderabad, TS 500081"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/sunil_singh_profile.webp"
}, {
  code: "REG / 02 / JAI",
  name: "Jaipur",
  region: "NORTH INDIA",
  address: ["MI Road", "Heritage District", "Jaipur, RJ 302001"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/anjali_rao_profile.webp"
}, {
  code: "REG / 03 / GOA",
  name: "Goa",
  region: "WEST INDIA",
  address: ["Panjim City", "Coastal Hub", "Goa, GA 403001"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/vikram_mehta_profile.webp"
}, {
  code: "REG / 04 / BLR",
  name: "Bangalore",
  region: "SOUTH INDIA",
  address: ["MG Road", "Business Center", "Bangalore, KA 560001"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/priya_sharma_profile.png"
}, {
  code: "REG / 05 / KOL",
  name: "Kolkata",
  region: "EAST INDIA",
  address: ["Park Street", "Central Hub", "Kolkata, WB 700016"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/arjun_das_profile.png"
}, {
  code: "REG / 06 / SHM",
  name: "Shimla",
  region: "NORTH INDIA",
  address: ["The Mall Road", "Mountain Ops", "Shimla, HP 171001"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/neha_gupta_profile.webp"
}, {
  code: "REG / 07 / KOC",
  name: "Kochi",
  region: "SOUTH INDIA",
  address: ["Marine Drive", "Coastal Ops", "Kochi, KL 682011"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/rahul_nair_profile.webp"
}, {
  code: "REG / 08 / AGRA",
  name: "Agra",
  region: "NORTH INDIA",
  address: ["Taj Ganj", "Heritage Ops", "Agra, UP 282001"],
  phone: "+91 79721 95929",
  email: "sunil.singh@hotelrevbaba.com",
  hours: "Mon–Sat 9a–7p",
  status: "CONSULTING",
  manager: "Sunil Singh",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/sonia_verma_profile.webp"
}];
export default function RegionalRevenueGrid() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: pillRef,
    isVisible: pillVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const firstRow = hubs.slice(0, 4);
  const secondRow = hubs.slice(4, 8);
  return <section data-section-id="823" id="regionalrevenuegrid" className="bg-background text-foreground py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center justify-center gap-2 mb-6">
            <span className="inline-block size-1.5 rounded-lg bg-secondary animate-pulse" />
            <span className="font-mono text-xs tracking-[0.2em] uppercase text-foreground/70">
              Expert Presence
            </span>
          </div>
          <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[64px] leading-[1.05] tracking-tight text-foreground">
            Regional Expertise. <span className="italic font-light">National Impact.</span>
          </h2>
          <p className="mt-6 font-sans text-base text-foreground/70 max-w-xl mx-auto">
            Strategic revenue management hubs across India, delivering data-driven growth for your property.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {firstRow.map((hub, i) => <HubCard key={hub.code} hub={hub} index={i} dataIndex={i} />)}
        </div>

        <div ref={pillRef} data-index={0} className={`relative my-10 flex justify-center transition-all duration-700 ease-out ${pillVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-px bg-foreground/10 hidden md:block" />
          <Link to="/ContactPage" className="relative inline-flex items-center gap-3 rounded-lg bg-secondary px-6 py-3 font-mono text-[11px] md:text-xs tracking-[0.18em] uppercase text-white hover:opacity-90 transition-all">
            <span>Schedule a Revenue Audit Today</span>
            <span className="inline-block size-1.5 rounded-lg bg-white animate-pulse" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {secondRow.map((hub, i) => <HubCard key={hub.code} hub={hub} index={i + 4} dataIndex={i} />)}
        </div>
      </div>
    </section>;
}
type Hub = {
  code: string;
  name: string;
  region: string;
  address: string[];
  phone: string;
  email: string;
  hours: string;
  status: string;
  manager: string;
  avatar: string;
};
function HubCard({
  hub,
  index,
  dataIndex
}: {
  hub: Hub;
  index: number;
  dataIndex: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const initials = hub.manager.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
  const telHref = `tel:${hub.phone.replace(/[^0-9+]/g, "")}`;
  const mailHref = `mailto:${hub.email}`;
  return <div ref={ref} data-index={dataIndex} style={{
    transitionDelay: `${index * 60}ms`
  }} className={`group relative bg-card border border-border rounded-lg p-7 flex flex-col aspect-[4/5] transition-all duration-700 ease-out hover:-translate-y-0.5 hover:border-secondary shadow-md ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <div className="flex items-center justify-between">
        <span className="font-mono text-[11px] tracking-[0.15em] text-foreground/60 group-hover:text-secondary transition-colors">
          {hub.code}
        </span>
        <span className="inline-block size-1.5 rounded-lg bg-secondary animate-pulse" />
      </div>

      <div className="mt-5">
        <h3 className="font-serif font-default text-[26px] leading-tight tracking-tight text-foreground">
          {hub.name}
        </h3>
        <p className="mt-1.5 font-mono text-[10px] tracking-[0.18em] uppercase text-foreground/55">
          {hub.region}
        </p>
      </div>

      <div className="my-5 h-px w-full bg-border" />

      <div className="space-y-4 flex-1">
        <div>
          <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-foreground/45 mb-1.5">
            Location
          </p>
          <div className="font-sans text-[13px] leading-relaxed text-foreground/80">
            {hub.address.map((line, i) => <div key={i} data-index={i}>
                {line}
              </div>)}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Phone className="size-3.5 text-secondary shrink-0" />
          <Link to={telHref} className="font-serif font-default text-[17px] text-foreground hover:text-secondary transition-colors">
            {hub.phone}
          </Link>
        </div>

        <div className="flex items-center gap-2">
          <Mail className="size-3.5 text-secondary shrink-0" />
          <Link to={mailHref} className="font-mono text-[12px] text-foreground/75 hover:text-secondary transition-colors break-all">
            {hub.email}
          </Link>
        </div>

        <div className="flex items-center gap-2">
          <Clock className="size-3.5 text-secondary shrink-0" />
          <span className="font-mono text-[12px] text-foreground/75">
            {hub.hours}
          </span>
        </div>

        <div className="flex items-center gap-1.5">
          <span className="inline-block size-1.5 rounded-lg bg-secondary" />
          <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-foreground/70">
            {hub.status}
          </span>
        </div>
      </div>

      <div className="my-5 h-px w-full bg-border" />

      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <SafeHydrate><Avatar className="size-8 rounded-lg border border-border">
            <AvatarImage src={hub.avatar} alt={hub.manager} />
            <AvatarFallback className="rounded-lg bg-muted text-foreground text-[10px] font-mono">
              {initials}
            </AvatarFallback>
          </Avatar></SafeHydrate>
          <span className="font-sans text-[12px] text-foreground/80 truncate">
            {hub.manager}
          </span>
        </div>
        <Link to={telHref} className="font-mono text-[11px] tracking-[0.1em] text-secondary hover:text-foreground transition-colors whitespace-nowrap">
          Call Now →
        </Link>
      </div>
    </div>;
}